import getJsonLMParts from './getJsonLMParts'

const preparePart = (part, group) => {
    part.article = part.article.toUpperCase()
    part.original_article = part.original_article.toUpperCase()
    part.brand_title = part.brand_title.toUpperCase()
    part.price_src = parseFloat(part.price_src)
    part.price_rub_src = parseFloat(part.price_rub_src)
    part.group = group
    part.quantity = parseInt(part.quantity)
    part.price_eur = part.price_eur.replace('&euro;', '€')
    part.delivery_time = part.delivery_time.replace('&asymp;', '≈')
    part.delivery = parseInt(part.delivery)

    return part
}

const getParts = () => {
    const jsonLMParts = getJsonLMParts()
    var flat_parts = []

    for (let group in jsonLMParts) {
        for (let art_brand in jsonLMParts[group]) {
            jsonLMParts[group][art_brand].forEach(function (part) {
                part = preparePart(part, group)
                flat_parts.push(part)
            })
        }
    }
    return flat_parts
}

export default getParts
